import { gql } from '@apollo/client';

export const SUBSCRIBE_TO_FIXTURE_CHANNEL = gql`
subscription FixtureMetricChannel(
    $aetFixtureId: String!
    $extFixtureId: String!
) {
    fixtureMetricChannel(
        aetFixtureId: $aetFixtureId
        extFixtureId: $extFixtureId
    ) {
        aetFixtureId
        extFixtureId
        databaseName
        fixtureName
        aecheckdatasource {
            catName
            catLabel
            enabled
            subCatList {
                catName
                catLabel
                enabled
            }
        }
    }
}
`;